import React, {Component} from 'react';
import {availableLanguages, getLanguage, lStrings} from '../Constants/Strings';
import {Link, NavLink} from 'react-router-dom'
import Dropdown from 'react-dropdown'
import 'react-dropdown/style.css'

const options = [
    {value: 'ja', label: '日本語'},
    {value: 'en', label: 'English'},
    {value: 'ko', label: '한국어'}
]
const currentLang = lStrings.getLanguage();

class Header extends Component {

    navRef;
    navbarRef;
    handleBodyClickListener = null;

    constructor() {
        super();
        let langNum = 0;
        for (let i = 0; i < options.length; i++) {
            if (options[i].value === currentLang) {
                langNum = i;
            }
        }

        this.state = {
            navCollapse: false,
            selected: options[langNum]
        };
        this._onSelect = this._onSelect.bind(this);

        this.navRef = React.createRef();
        this.navbarRef = React.createRef();
        this.handleBodyClickListener = this.handleBodyClick.bind(this);
    }

    handleBodyClick(e) {
        if (this.navbarRef && this.navbarRef.current) {
            let target = e.target;
            if (target && target !== null) {
                while (target.parentNode && target.parentNode !== null) {
                    target = target.parentNode;
                    if (target.id === this.navbarRef.current.id) {
                        return;
                    }
                }
            }
        }
        if (this.toggleNav()) {
            e.preventDefault();
            e.stopPropagation();
        }
    }

    componentDidMount() {
        const main = window.document.getElementById('app-main');
        if (main && main !== null) {
            main.addEventListener('click', this.handleBodyClickListener);
        }
        // const $ = window.jQuery;
        // $('#navbarNav').on('shown.bs.collapse', function () {
        //     $(window).on('touchmove.noScroll', function (e) {
        //         e.preventDefault();
        //     });
        // });
    }

    toggleNav() {
        if (this.navbarRef && this.navbarRef.current && this.navbarRef.current.classList.contains('show')) {
            const $ = window.jQuery;
            $(this.navbarRef.current).collapse('toggle');
            return true;
        }
        return false;
    }

    componentWillUnmount() {
        const main = window.document.getElementById('app-main');
        if (main && main !== null) {
            main.removeEventListener('click', this.handleBodyClickListener);
        }
    }

    _handleClick(menuItem) {
        this.setState({active: menuItem});
    }

    _onSelect(option) {
        // console.log('You selected ', option.label);
        this.setState({selected: option});
        let lang = option.value;
        if (lang && lang !== undefined && availableLanguages.indexOf(lang) >= 0) {

        } else {
            lang = 'ja';
        }
        if (process.env.REACT_APP_HASH === 'true') {
            let href = window.location.origin + window.location.pathname;
            let hash = window.location.hash;
            hash = hash.replace(/#\/([a-z]+)\//, '#/' + lang + '/');
            window.location.assign(href + hash);
            window.location.reload(true);
        } else {
            let href = window.location.origin;
            let hash = window.location.pathname;
            hash = hash.replace(/\/([a-z]+)\//, '/' + lang + '/');
            window.location.assign(href + hash);
        }
    }

    render() {
        const defaultOption = this.state.selected;
        let urlPrefix = './';
        if (this.props.urlPrefix && this.props.urlPrefix !== null && this.props.urlPrefix.length > 0) {
            urlPrefix = this.props.urlPrefix;
        }

        let locale = getLanguage();

        return (
            <div className="container-fluid navbar-border fixed-top">
                <div className="row">
                    <div className="container">
                        <nav ref={this.navRef}
                             className={'navbar navbar-expand-lg navbar-light row align-items-center' + (this.state.navCollapse ? ' top-nav-collapse' : '')}>

                    <span
                        className="navbar-toggler order-lg-2"
                        data-toggle="collapse"
                        data-target="#navbarNav"
                        aria-controls="navbarNav"
                        aria-expanded="false"
                        aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </span>

                            <Link className="navbar-brand order-lg-1 ml-md-0 ml-3" to={urlPrefix + "./main"}>
                                <img alt={lStrings.title_company_name} className="logo" src="./img/logo.svg"
                                     height="22px"/>
                            </Link>

                            <div className="collapse width navbar-collapse order-lg-3" id="navbarNav"
                                 ref={this.navbarRef}
                                 onClick={this.toggleNav.bind(this)}>
                                <ul className="navbar-nav">
                                    <li className="navbar-brand-logo d-md-none">
                                        <Link to={urlPrefix + "./main"}>
                                            <img alt={lStrings.title_company_name} className="logo"
                                                 src="./img/logo.svg"
                                                 height="22px"/>
                                        </Link>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink
                                            to={"/" + locale + "/service"}
                                            className="nav-link">Service</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to={"/" + locale + "/team"}
                                                 className="nav-link">Team</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to={"/" + locale + "/news"}
                                                 className="nav-link">News</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to={"/" + locale + "/contact"}
                                                 className="nav-link">Contact</NavLink>
                                    </li>
                                    <li className="nav-item">
                                        <NavLink to={"/" + locale + "/jobs"}
                                                 className="nav-link">Job</NavLink>
                                    </li>
                                </ul>
                                <div className="navbar-copyright d-md-none">
                            <span className="footer-copyright pl-4">
                                &copy; {lStrings.title_company_name_formal}
                            </span>
                                    <span className="footer-slogan pl-4 d-block d-md-inline">
                                {lStrings.title_company_slogan}</span>
                                </div>
                            </div>
                            <div className="text-right order-lg-4" style={{'flexGrow': '1'}}>
                                <Dropdown options={options}
                                          onChange={this._onSelect}
                                          value={defaultOption}
                                          placeholder="Select an option"/>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        );
    }
}

export default Header;



// WEBPACK FOOTER //
// ./src/Components/Header.js